/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Sign_In_ExpiredInputs */

const fr_auth_sign_in_expired = /** @type {(inputs: Auth_Sign_In_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tentative de connexion a expiré. Reconnectez-vous.`)
};

const en_auth_sign_in_expired = /** @type {(inputs: Auth_Sign_In_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The sign-in attempt expired. Sign in again.`)
};

/**
* | output |
* | --- |
* | "The sign-in attempt expired. Sign in again." |
*
* @param {Auth_Sign_In_ExpiredInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_sign_in_expired = /** @type {((inputs?: Auth_Sign_In_ExpiredInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Sign_In_ExpiredInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_sign_in_expired(inputs)
	return fr_auth_sign_in_expired(inputs)
});